module.exports = __webpack_public_path__ + "static/media/featuredLogo6.7a7f09b1.png";